import { useState, useEffect } from 'react';
import { apiClient } from '../../../../services/apiClient';

/**
 * Custom hook to fetch timestamp-typed object attribute names for an object type
 * @param {string} activeFile - The active OCEL file name
 * @param {string} objectType - Object type to scope the attributes to
 * @returns {Object} - { dateAttributes: string[], loading: boolean }
 */
export const useObjectDateAttributes = (activeFile, objectType) => {
  const [dateAttributes, setDateAttributes] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!activeFile || !objectType) {
      setDateAttributes([]);
      return;
    }
    let cancelled = false;
    setLoading(true);
    apiClient
      .get('/ocel/object-type-attributes', {
        params: { file_type: activeFile, object_type: objectType },
      })
      .then((res) => {
        if (cancelled) return;
        setDateAttributes(res.data?.date_attributes || []);
      })
      .catch(() => {
        if (!cancelled) setDateAttributes([]);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => { cancelled = true; };
  }, [activeFile, objectType]);

  return { dateAttributes, loading };
};
